import React, { Component } from "react";
import { ToastContainer, Zoom } from 'react-toastify';
import { withRouter } from "next/router";
import Cookie from '../services/Cookie'
import Head from 'next/head';
import SlackWebHook from '../services/Slack';
import PropTypes from "prop-types";

class SiteLayout extends Component {
    componentDidMount(){
        let themeData = Cookie.getCookie('_data-theme');
        if (themeData === 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
        }
    }

    componentDidCatch(error, info) {
        SlackWebHook.sendSlackMessage('SiteLayout','componentDidCatch',`${error.message}-${info}`);
    }

    render() {
        return (
            <React.Fragment>
                <Head>
                    <title>{process.env.NEXT_PUBLIC_APP_NAME} Student Panel</title>
                </Head>
                <main className="overflow-x-hidden">
                    {this.props.children}
                </main>
                <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    theme="colored"
                    hideProgressBar
                    transition={Zoom}
                    closeOnClick
                    rtl={false}
                    toastClassName="px-3 txt-16--body text-white"
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover={false}
                />
            </React.Fragment>
        )
    }
}

const propTypes = {
    /** Children element */
    children: PropTypes.node,
};

const defaultProps = {
};

SiteLayout.propTypes = propTypes;
SiteLayout.defaultProps = defaultProps;

export default withRouter(SiteLayout);